import { ContentItemViewNodesType } from 'components/WorkspaceEditor/types'

export type BestPracticeContentItem = Partial<ContentItemViewNodesType> & {
    isBestPractice?: boolean
    isGlobalBestPractice?: boolean
    contentItemView?: Partial<ContentItemViewNodesType>
    contentItemNodes?: Partial<ContentItemViewNodesType>[]
}

export const useBestPracticesData = (contentItem: BestPracticeContentItem) => {
    const isBestPractice =
        contentItem.isBestPractice ??
        contentItem.contentItemView?.isBestPractice ??
        false

    const isGlobalBestPractice =
        contentItem.isGlobalBestPractice ??
        contentItem.contentItemView?.isGlobalBestPractice ??
        false

    return {
        isBestPractice: !!isBestPractice,
        isGlobalBestPractice: !!isGlobalBestPractice,
    }
}
